import React from "react";
import { Table } from "react-bootstrap";
import "../../../assets/styles/informationLayer.scss";

const AddressLayerData = ({ addressData }) => {
  return (
    <Table className="layer-table" responsive>
      <tbody>
        <tr>
          <td>ID:</td>
          <td>{addressData.id}</td>
        </tr>
        <tr>
          <td>Województwo:</td>
          <td>{addressData.province || "-"}</td>
        </tr>
        <tr>
          <td>Miejscowość:</td>
          <td>{addressData.cityName || "-"}</td>
        </tr>
        <tr>
          <td>Adres:</td>
          <td>
            {
              (() => {
                const parts = [addressData.street, addressData.streetNumber]
                  .filter(v => v != null && v !== "");
                return parts.length ? parts.join(" ") : "-";
              })()
            }
          </td>
        </tr>
        <tr>
          <td>Typ rekordu:</td>
          <td>{addressData.type || addressData.typRekordu || "-"}</td>
        </tr>
        <tr>
          <td>Kod pocztowy:</td>
          <td>{addressData.postcode || addressData.kodPocztowy || "-"}</td>
        </tr>
        <tr>
          <td>Liczba lokali B:</td>
          <td>{addressData.countB ?? "-"}</td>
        </tr>
        <tr>
          <td>Liczba lokali C:</td>
          <td>{addressData.countC ?? "-"}</td>
        </tr>
        <tr>
          <td>BUDYNEK:</td>
          <td>{addressData.buildingType || "-"}</td>
        </tr>
        <tr>
          <td>Status geokodowania:</td>
          <td>{addressData.geoStatus || "-"}</td>
        </tr>
      </tbody>
    </Table>
  );
};

export default AddressLayerData;
